// extracted by mini-css-extract-plugin
module.exports = {"page":"page_page__R_0X0","content":"page_content__VHLQv","wrap":"page_wrap__qXNJQ","title":"page_title__yYrnb"};